import moment from "moment/moment";

export const formatDate = (timestamp) => {
  const changeDate = moment(timestamp, 'YYYY-MM-DD').format('DD MMM YY'); 
  return changeDate;
};

export const formatMonth = (timestamp) => {
  const changeMonth = moment(timestamp, 'YYYY-MM').format('MMM YY');
  return changeMonth;
}

export const attendanceDateFormat = (apiDate) => {
  console.log(`API Date: ${apiDate}`);
  
  return moment(apiDate, 'DD MMM YYYY').format('YYYY-MM-DD');
}

export const formatTime = (timestamp) => {
   const cleanTime = timestamp.replace(/Z$/, '');
  return moment(cleanTime).format('hh:mm A');
};

export const formatAttendanceTime = (timestamp) => {
  return moment.utc(timestamp).local().format('hh:mm:ss')
};

export const formatToInputDate = (date) => {
  const d = new Date(date);
  return d.toISOString().split('T')[0]; // "YYYY-MM-DD"
};
